import type { FC } from 'react';
import React, { useMemo } from 'react';

import { defaultFontSize, defaultLineHeight, defaultTheme } from './config';
import { calcHeight, prepareSet, getTheme, getClassNames } from './helpers';
import type { IFontPreset, TProps, THeight, TThemeValid } from './models';

export const Text: FC<React.PropsWithChildren<TProps>> = ({
    Tag = 'p',
    // todo: на следюущей итерации добавить дефолтное значение из пропа Tag
    tag,
    dataTestId = 'text',
    children,
    className,
    decoration,
    fontSize = defaultFontSize,
    showDataNosnippet,
    fontWeight,
    kind,
    lineHeight,
    lines,
    noClasses,
    styles,
    fontPreset,
    theme = defaultTheme,
    textTransform,
    view,
}) => {
    const set: IFontPreset = useMemo(
        () =>
            prepareSet({
                fontPreset,
                view,
                textTransform,
                lineHeight,
                fontWeight,
                fontSize,
            }),
        [fontPreset, view, textTransform, lineHeight, fontWeight, fontSize]
    );

    const textTheme: TThemeValid = useMemo(() => getTheme(theme), [theme]);

    const classNamesResult = useMemo(
        () => getClassNames({ set, className, textTheme, kind, decoration, noClasses, styles }),
        [set, className, textTheme, decoration, noClasses, styles, kind]
    );

    const height: THeight = useMemo(
        () =>
            calcHeight({
                lines,
                lineHeight: set.lineHeight || defaultLineHeight,
                fontSize: set.fontSize,
            }),
        [lines, set]
    );
    const TagElement = tag || Tag;

    return (
        <TagElement
            className={classNamesResult}
            data-nosnippet={showDataNosnippet ? true : undefined}
            data-test-id={dataTestId}
            style={{ height }}
        >
            {children}
        </TagElement>
    );
};
